<table
  class="tbl"
  role="table"
  aria-label="Data table"
>
  <thead>
    <tr>
      @for (col of visibleColumns(); track col) {
        <th
          [style.width]="col.width || null"
          [class.align-center]="col.align === 'center'"
          [class.align-right]="col.align === 'right'"
          (click)="setSort(col)"
          [attr.aria-sort]="ariaSort(col)"
          [class.sortable]="col.sortable"
          scope="col"
        >
          <div class="th-inner">
            @if (col.headerTemplate) {
              <ng-container *ngTemplateOutlet="col.headerTemplate"></ng-container>
            } @else {
              <span class="label">{{ col.header }}</span>
            }
            @if (col.sortable) {
              <span class="sort-indicator">
                <i
                  class="arrow"
                  [class.active]="sortKey() === col.key.toString() && sortDir() === 'asc'"
                  >▲</i
                >
                <i
                  class="arrow"
                  [class.active]="sortKey() === col.key.toString() && sortDir() === 'desc'"
                  >▼</i
                >
              </span>
            }
          </div>
        </th>
      }
    </tr>
  </thead>

  <tbody>
    @if (loading()) {
      <tr>
        <td
          [attr.colspan]="visibleColumns().length"
          class="loading"
        >
          <lib-loader size="small"></lib-loader>
        </td>
      </tr>
    } @else {
      @for (row of processed(); track trackBy($index, row); let r = $index) {
        <tr
          [class.clickable-row]="rowClickable()"
          [attr.data-token]="$any(row)['token'] || null"
          [attr.data-is-child]="$any(row)['isChild'] || null"
          [attr.data-parent-token]="$any(row)['parentToken'] || null"
          (click)="rowClickable() && onRowClick(row)"
        >
          @for (col of visibleColumns(); track col; let c = $index) {
            @if (!$any(row)['isChild'] || c < 2) {
              <td
                [class.align-center]="col.align === 'center'"
                [class.align-right]="col.align === 'right'"
                [attr.colspan]="
                  $any(row)['isChild'] && c === 1 ? visibleColumns().length - 1 : null
                "
              >
                @if (col.cellTemplate) {
                  <ng-container
                    *ngTemplateOutlet="
                      col.cellTemplate;
                      context: {
                        $implicit: row,
                        row: row,
                        value: raw(row, col),
                        col: col,
                        rowIndex: r,
                        colIndex: c,
                      }
                    "
                  >
                  </ng-container>
                } @else if (col.cell) {
                  <span [innerHTML]="renderCell(row, col, r, c)"></span>
                } @else {
                  <span>{{ text(row, col) }}</span>
                }
              </td>
            }
          }
        </tr>
      }

      @if (!processed().length) {
        <tr>
          <td
            [attr.colspan]="visibleColumns().length"
            class="empty"
          >
            {{ noDataMessage() }}
          </td>
        </tr>
      }
    }
  </tbody>
</table>
